import { __rest as e } from "tslib";
import * as a from "react";
import t from "classnames";
import { countryDialCodes as o } from "@aws-amplify/ui";
import { ComponentClassNames as l } from "../shared/constants.js";
import { SelectField as s } from "../SelectField/SelectField.js";
var r = a.forwardRef(function (r, i) {
  var m = r.className,
    d = r.dialCodeList,
    c = r.isReadOnly,
    n = e(r, ["className", "dialCodeList", "isReadOnly"]);
  var p = null != d ? d : o,
    f = a.useMemo(function () {
      return p.map(function (e) {
        return a.createElement("option", {
          key: e,
          value: e,
          disabled: c
        }, e);
      });
    }, [p, c]);
  return a.createElement(s, Object.assign({
    "aria-disabled": c,
    autoComplete: "tel-country-code",
    className: t(l.CountryCodeSelect, l.DialCodeSelect, m),
    labelHidden: !0,
    ref: i
  }, n), f);
});
r.displayName = "CountryCodeSelect";
export { r as CountryCodeSelect };